//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './PasswordValidationSettingsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export function getUrl(): string {
  let url_ = getBaseUrl() + "/api/password-validation/settings";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.PasswordValidationSettingsDto, unknown, Types.PasswordValidationSettingsDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PasswordValidationSettingsDto, unknown, Types.PasswordValidationSettingsDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'PasswordValidationSettingsClient',
      'get',
    ]);
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
axiosConfig    );
}

export function useGetQuery<TSelectData = Types.PasswordValidationSettingsDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.PasswordValidationSettingsDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.PasswordValidationSettingsDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PasswordValidationSettingsDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PasswordValidationSettingsDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.PasswordValidationSettingsDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetData(queryClient: QueryClient, updater: (data: Types.PasswordValidationSettingsDto | undefined) => Types.PasswordValidationSettingsDto, ) {
  queryClient.setQueryData(getQueryKey(),
    updater
  );
}

export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PasswordValidationSettingsDto | undefined) => Types.PasswordValidationSettingsDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(): string {
  let url_ = getBaseUrl() + "/api/password-validation/settings";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(): MutationKey {
  return trimArrayEnd([
      'PasswordValidationSettingsClient',
      'patch',
    ]);
}

export function usePatchMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.PasswordValidationSettingsPatchDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.PasswordValidationSettingsPatchDto, TContext> {
  const key = patchMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PasswordValidationSettingsPatchDto) => Client.patch(dto),
    mutationKey: key,
  });
}